import React from "react";
import { useAppContext } from "../context/appContext";
import closeIcon from "../assets/icons/close.svg";
import logoIcon from "../assets/icons/logo.svg";
import { useLenis } from "lenis/react";
import { Logo } from "../components/logo";
import { TextLg, TextMd } from "../components/text";
import { NavLink } from "./topBar";

export const Menu = ({ className = "" }) => {
  const { routing, menuOpen, setMenuOpen } = useAppContext();
  const { navigate, baseUrl } = routing;

  return (
    <div
      className={`
        fixed inset-0 transition-[background-color] duration-700 h-screen
        ${className}
      `}
      style={{
        pointerEvents: menuOpen ? "all" : "none",
        backgroundColor: menuOpen ? `rgba(0,0,0,0.5)` : `rgba(0,0,0,0)`,
      }}
      onClick={() => {
        setMenuOpen(false);
      }}
    >
      <div
        className={`
          relative h-[100dvh]
          w-full max-w-[450px] lg:max-w-[480px] 4xl:max-w-[510px] 5xl:max-w-[600px]  
        `}
      >
        <div
          className={`
            bg-gradient w-full h-full absolute p-1
            transition-[left] duration-[600ms] shadow-xl
            border-r border-neutral-500/15 flex flex-col
          `}
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{
            left: menuOpen ? 0 : "-100%",
          }}
        >
          <button
            className="h-16 p-5 absolute right-0 top-0"
            onClick={() => {
              setMenuOpen(false);
            }}
          >
            <img className="white-svg h-full" src={closeIcon} />
          </button>

          <div 
            className="flex flex-col justify-center items-center"
            onClick={()=>{
              navigate(baseUrl);
            }}
          >
            <div className="w-full flex flex-col grow justify-center items-center p-3">
              <img className="h-[15vh] min-h-[112px]" src={logoIcon} />
              <TextMd 
                className="w-full flex justify-center pb-6"
              >
                <Logo className="px-3 py-1" />
              </TextMd>
            </div>
            
          </div>

          <div className="mx-9 h-px bg-neutral-500/15" />

          <TextMd className="flex flex-col text-gray-100 py-6 *:p-4 *:w-full *:text-start *:px-9 items-start">
            <NavLink path={baseUrl}>Home</NavLink>
            <NavLink path="/data-analytics">Data Analytics</NavLink>
            <NavLink path="/web-development">Web Development</NavLink>
            <NavLink path="/contact">Contact</NavLink>
          </TextMd>

          <div className="text-gray-100 font-semibold mt-auto">
            <div className="mx-9 h-px bg-neutral-500/15" />

            <button 
              className="p-4 w-full justify-center flex"
              onClick={()=>{
                setMenuOpen(false);
              }}
            >
              Close
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};
